import {
  Journey,
} from '@dapi/sdk';
import {
  JourneysStore,
  selectAllJourneys,
  selectSelectedJourney,
} from '@des/store/journeys';
import {
  select,
} from '@ngrx/store';
import {
  Observable,
} from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
} from 'rxjs/operators';

/**
 * Selected Journey
 */
export const getSelectedJourney = () => (source: Observable<JourneysStore>) =>
  source.pipe(
    filter((store) => !!store.journeys),
    select(selectSelectedJourney),
    filter<Journey>((journey) => !!journey),
    distinctUntilChanged((a, b) => a.id === b.id && a.journeyElements.length === b.journeyElements.length)
  );

/**
 * Journeys array
 */
export const getJourneys = () => (source: Observable<JourneysStore>) =>
  source.pipe(
    filter((store) => !!store.journeys),
    select(selectAllJourneys),
    map((journeys) => ({
      journeys
    })),
    distinctUntilChanged()
  );
